import { render, staticRenderFns } from "./HealthReportBox.vue?vue&type=template&id=7d491362&scoped=true&"
import script from "./HealthReportBox.vue?vue&type=script&lang=ts&"
export * from "./HealthReportBox.vue?vue&type=script&lang=ts&"
import style0 from "./HealthReportBox.vue?vue&type=style&index=0&id=7d491362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d491362",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VListItem,VListItemAvatar,VListItemContent,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d491362')) {
      api.createRecord('7d491362', component.options)
    } else {
      api.reload('7d491362', component.options)
    }
    module.hot.accept("./HealthReportBox.vue?vue&type=template&id=7d491362&scoped=true&", function () {
      api.rerender('7d491362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/health-reports/components/HealthReportBox.vue"
export default component.exports